import {Results, Success} from 'common/models/success';
import {IntegrationsByType} from 'common/models/success/integration';
import {SurveySettings} from 'common/models/survey';
import {System} from 'common/models/system';

interface PreloadedState {
    survey?: SurveySettings;
    success?: {data: Success; integrations: IntegrationsByType; results: Results};
    system?: System;
}

export const preloadedState = {} as PreloadedState;
